import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

// forceMount keeps every answer in the DOM (hidden until opened) so search
// engines can read the same Q&A that the FAQPage schema describes.
export default function FaqAccordion({ faqs }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`q-${i}`} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
          <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-slate-900 py-5 hover:no-underline">
            {f.q}
          </AccordionTrigger>
          <AccordionContent forceMount className="text-slate-600 text-base leading-relaxed pb-5">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
